import { render, staticRenderFns } from "./BnplApplications.vue?vue&type=template&id=b5ba996e&scoped=true&"
import script from "./BnplApplications.vue?vue&type=script&lang=js&"
export * from "./BnplApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ba996e",
  null
  
)

export default component.exports